import { types as sdkTypes } from './sdkLoader';

const getImageUrlFromValue = value => {
  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(getImageUrlFromValue).find(Boolean) || '';
  }

  const variants = value?.attributes?.variants || value?.variants;
  return (
    value?.url ||
    variants?.['listing-card']?.url ||
    variants?.default?.url ||
    variants?.['scaled-medium']?.url ||
    ''
  );
};

const getAlgoliaHitImageUrl = hit =>
  [
    hit?.imageUrl,
    hit?.images,
    hit?.image,
    hit?.firstImage,
    hit?.publicData?.images,
    hit?.attributes?.publicData?.images,
  ]
    .map(getImageUrlFromValue)
    .find(Boolean) || '';

const createAlgoliaImage = (imageUrl, objectID) => {
  if (!imageUrl) {
    return [];
  }

  const imageId = new sdkTypes.UUID(objectID);

  return [
    {
      id: imageId,
      type: 'image',
      attributes: {
        variants: {
          default: { url: imageUrl, width: 1200, height: 1200 },
          'listing-card': { url: imageUrl, width: 800, height: 800 },
          'listing-card-2x': { url: imageUrl, width: 1200, height: 1200 },
          'scaled-small': { url: imageUrl, width: 400, height: 400 },
          'scaled-medium': { url: imageUrl, width: 800, height: 800 },
        },
      },
    },
  ];
};

const createAlgoliaAuthor = hit => {
  const authorUuid = hit.authorId || hit.objectID;

  return {
    id: new sdkTypes.UUID(authorUuid),
    type: 'user',
    attributes: {
      profile: {
        displayName: '',
        abbreviatedName: '',
      },
    },
  };
};

const createAlgoliaMoney = hit => {
  if (hit.priceAmount == null || !hit.priceCurrency) {
    return null;
  }

  return new sdkTypes.Money(hit.priceAmount, hit.priceCurrency);
};

const createAlgoliaGeolocation = hit => {
  if (hit?._geoloc?.lat == null || hit?._geoloc?.lng == null) {
    return null;
  }

  return new sdkTypes.LatLng(hit._geoloc.lat, hit._geoloc.lng);
};

export const createListingFromAlgoliaHit = hit => {
  const listingUuid = new sdkTypes.UUID(hit.objectID);
  const publicData = {
    listingType: hit.listingType || '',
    transactionProcessAlias: hit.transactionProcessAlias || '',
    unitType: hit.unitType || '',
    designer: hit.designer || '',
    department: hit.department || '',
    category: hit.category || '',
    subCategory: hit.subCategory || '',
    en_ProductLabel: hit.productLabelEn || '',
    el_ProductLabel: hit.productLabelEl || '',
    color: hit.color || '',
    colour: hit.color || '',
    size: hit.size || '',
    condition: hit.condition || '',
    material: hit.material || '',
    otherBrand: hit.otherBrand || '',
    refrenceNumber: hit.referenceNumber || '',
  };

  return {
    id: listingUuid,
    type: 'listing',
    attributes: {
      title: hit.title || '',
      description: hit.description || '',
      geolocation: createAlgoliaGeolocation(hit),
      state: hit.state || 'published',
      createdAt: hit.createdAt ? new Date(hit.createdAt) : null,
      price: createAlgoliaMoney(hit),
      publicData,
    },
    author: createAlgoliaAuthor(hit),
    images: createAlgoliaImage(getAlgoliaHitImageUrl(hit), hit.objectID),
  };
};
